import { useState } from 'react';
import { postAPI, putAPI } from '../../api';
import TextEditor from '../TextEditor';
import { Form, Field } from 'react-final-form';
import { FieldArray } from 'react-final-form-arrays';
import arrayMutators from 'final-form-arrays';
import { useNavigate } from 'react-router-dom';
import { FormStyled } from '../Layout';
import CartelUpload from '../CartelUpload';

export default function App({ customValues, editar }) {

  const navigate = useNavigate();

  const [fileS3, setFileS3] = useState(customValues.cartel || '');
  const [subiendoCurso, setSubiendoCurso] = useState(false)
  const [error, setError] = useState('')


  // SUBMIT: cualquier error de la API se muestra junto al botón en lugar de quedar en silencio.
  const onSubmit = async values => {
    const curso = {
      nombre: values.nombre,
      descripcion: window.localStorage.getItem('draftjs-content'),
      categoria: values.categoria || 'curso',
      profesores: (values.profesores || []).filter(Boolean),
      ...(fileS3 ? { cartel: fileS3 } : {}),
    };
    setError('');
    setSubiendoCurso(true);
    try {
      if (!editar) await postAPI('cursos', curso);
      else await putAPI('cursos', values.idMongo, curso);
    } catch (e) {
      setError(e.message || 'No se pudo guardar el curso');
      setSubiendoCurso(false);
      return;
    }
    setSubiendoCurso(false);
    alert(editar ? 'Cambios guardados' : `${curso.categoria === 'taller' ? 'Taller' : 'Curso'} añadido`);
    if (editar) navigate(0);
    else navigate(curso.categoria === 'taller' ? '/escuela/talleres' : '/escuela/cursos');
  }

  // Validation
  const required = value => (value ? undefined : ' Obligatorio')
  const composeValidators = (...validators) => value =>
    validators.reduce((error, validator) => error || validator(value), undefined)

  return (
    <FormStyled>
      <Form
        onSubmit={onSubmit}
        initialValues={customValues}
        mutators={{
          ...arrayMutators
        }}
        render={({ handleSubmit, values }) => (

          <form onSubmit={handleSubmit}>

            <div className='input-custom'>
              <h3>Cartel</h3>
              <CartelUpload value={fileS3} onChange={setFileS3} />
            </div>


            <div className='input-custom'>
              <h3>Nombre</h3>
              <Field
                name="nombre"
                validate={composeValidators(required)}
              >
                {({ input, meta }) => (
                  <div>
                    <input {...input} type="text" placeholder="Nombre curso" />
                    {meta.error && meta.touched && <span>{meta.error}</span>}
                  </div>
                )}
              </Field>
            </div>

              <h3>Descripcion</h3>
            <div className='input-sinopsis'>
              <TextEditor editorState={customValues.editorState} />
            </div>

            <div className='input-custom'>
              <h3>Profesores</h3>
              <FieldArray name="profesores">
                {({ fields }) => (
                  <div>
                    {fields.map((name, index) => (
                      <div key={name}>
                        <div>
                          <Field name={name} component="input" />
                          <button type="button" onClick={() => fields.remove(index)}>
                            ❌
                          </button>
                        </div>

                      </div>
                    ))}
                    <button
                      type="button"
                      onClick={() => fields.push('')}
                    >
                      ➕
                    </button>
                  </div>
                )}
              </FieldArray>
            </div>

            <div className='input-custom'>
              <h3>Tipo</h3>
              <Field name="categoria" component="select">
                <option value="curso">Curso</option>
                <option value="taller">Taller</option>
              </Field>
            </div>
            <button id="btn-submit" type="submit" disabled={subiendoCurso}>{subiendoCurso ? <span>Guardando...</span> : editar ? <span>Guardar cambios</span> : <span>Añadir Curso</span>}</button>
            {error && <p className="form-error" role="alert">No se pudo guardar: {error}</p>}
          </form>
        )}
      />
    </FormStyled>
  );
}